import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../api';
import FormCliente from './FormCliente';

const inp = {
  padding: '8px 12px', borderRadius: 6, border: '1px solid #c8d0da',
  fontSize: 14, color: '#111', background: '#fff', width: '100%', boxSizing: 'border-box',
};

export function BuscaClientes() {
  const [busca, setBusca] = useState('');
  const [resultados, setResultados] = useState([]);
  const [aberto, setAberto] = useState(false);
  const wrapRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const editando = location.pathname.includes('/editar');

  useEffect(() => {
    if (busca.trim().length < 2) { setResultados([]); setAberto(false); return; }
    const t = setTimeout(async () => {
      try {
        const data = await api.listarClientes(busca);
        setResultados(data.slice(0, 10));
        setAberto(true);
      } catch { setResultados([]); }
    }, 300);
    return () => clearTimeout(t);
  }, [busca]);

  useEffect(() => {
    function clickFora(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setAberto(false);
    }
    document.addEventListener('mousedown', clickFora);
    return () => document.removeEventListener('mousedown', clickFora);
  }, []);

  function selecionar(c) {
    setBusca('');
    setResultados([]);
    setAberto(false);
    navigate(`/clientes/${c._id}/editar`);
  }

  return (
    <div ref={wrapRef} style={{ position: 'relative', marginBottom: 20 }}>
      <div style={{ display: 'flex', gap: 8 }}>
      <div style={{ position: 'relative', flex: 1 }}>
        <input
          value={busca}
          onChange={e => setBusca(e.target.value)}
          onFocus={() => resultados.length > 0 && setAberto(true)}
          placeholder="Buscar por nome, CPF, CNPJ, marca ou processo..."
          style={inp}
        />
        {busca && (
          <button onClick={() => { setBusca(''); setResultados([]); setAberto(false); }} style={{
            position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
            background: 'none', border: 'none', color: '#9ca3af', fontSize: 16, cursor: 'pointer', padding: 0,
          }}>✕</button>
        )}
      </div>
      {editando && (
        <button onClick={() => navigate('/clientes')} style={{
          background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db',
          padding: '8px 14px', borderRadius: 6, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap',
        }}>
          Limpar
        </button>
      )}
      </div>

      {aberto && resultados.length > 0 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100,
          background: '#fff', border: '1px solid #c8d0da', borderRadius: 6,
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)', maxHeight: 280, overflowY: 'auto', marginTop: 4,
        }}>
          {resultados.map(c => {
            const marcas = (Array.isArray(c.processos) ? c.processos : []).map(p => p?.nome_marca).filter(Boolean).join(', ') || c.nome_marca || '';
            return (
              <div key={c._id} onClick={() => selecionar(c)}
                style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid #f3f4f6' }}
                onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                <div style={{ fontWeight: 600, fontSize: 14, color: '#0a1628' }}>{c.nome || c.responsavel || '—'}</div>
                {marcas && <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>🏷️ {marcas}</div>}
                {c.telefone && <div style={{ fontSize: 12, color: '#6b7280' }}>📞 {c.telefone}</div>}
                {c.outra_empresa && (
                  <div style={{ fontSize: 12, color: '#1d4ed8', marginTop: 2 }}>
                    🏢 achado pela outra empresa: {c.outra_empresa.nome}{c.outra_empresa.documento ? ` — ${c.outra_empresa.documento}` : ''}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      {aberto && busca.trim().length >= 2 && resultados.length === 0 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100,
          background: '#fff', border: '1px solid #c8d0da', borderRadius: 6,
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)', padding: 14, marginTop: 4,
          fontSize: 13, color: '#6b7280', textAlign: 'center',
        }}>
          Nenhum cliente encontrado
        </div>
      )}
    </div>
  );
}

export default function ClientesPage() {
  const location = useLocation();
  const dadosCRM = location.state?.fromCRM || null;
  return (
    <div>
      <BuscaClientes />
      <FormCliente dadosIniciais={dadosCRM} key={dadosCRM ? JSON.stringify(dadosCRM) : 'novo'} />
    </div>
  );
}
